import { selfGuidedTourTourRelatedQuestions } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';

/**
 * Fetches the tour related questions for a given specId.
 * @param {string} specId - The specId to fetch tour related questions for.
 * @returns {Observable} An observable that emits the tour related questions or an error object.
 */
export default function getTourRelatedQuestions$(specId) {
  const url = `${selfGuidedTourTourRelatedQuestions}?specId=${specId}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        return response.json();
      }
      return of({
        error: true,
        message: 'Error fetching data',
      });
    }),
    catchError((error) =>
      of({
        error: true,
        message: error.message,
      })
    )
  );
}
